import { BreadcrumbService } from './../../shared/services/breadcrum.service';
import { IState } from './../../shared/store/root.reducer';
import { AuthService } from './../../shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment.staging';


@Component({
  selector: 'app-staging-login',
  templateUrl: './staging-login.component.html',
  styleUrls: ['./staging-login.component.scss']
})
export class StagingLoginComponent implements OnInit {
  users: UserLogin[];

  constructor(
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.users = environment.users;
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

  login(cfid) {
    this.authService.clearUserFromLocalStorage();
    this.authService.login(cfid);
  }

}
interface UserLogin {
  name: string;
  cfid: string;
}
